module.exports = __webpack_public_path__ + "static/sc-02.0f6e1570.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/projects/drum-vae/sc-02.png
// module id = 88
// module chunks = 88197199937824 203598379525278 213720915766396